import { useDelete } from "../../hooks/useDelete";

export const DeleteAsset = async (asset_id) => {
  try {
    const data = await useDelete(
      `${process.env.REACT_APP_API_URL}/assets/${asset_id}`
    );
    return data.data;
  } catch (err) {
    return null;
  }
};
